import * as React from 'react';
import * as _ from 'underscore';
const compareObjects = require('fast-deep-equal');

import { IGlob } from '../../../../_common/application/ts/Glob';
import EditViewValidationMixin from '../../../../_common/platform/tsx/mixins/EditViewValidationMixin';

import NumberField from '../../../../_common/platform/ts/NumberField';
import BooleanField from '../../../../_common/platform/ts/BooleanField';
import { MultiWidgetField } from '../../../../_common/platform/ts/MultiWidgetField';
import { validators } from '../../../../_common/platform/ts/validators';
import * as Utils from '../../../../_common/platform/ts/Utilities';
import { WidgetData } from '../../../../_common/platform/ts/WidgetData';
import { EditTargetDialog } from '../../../../_common/platform/tsx/EditTargetDialog';
import { PasteButton } from '../../../../_common/platform/tsx/PasteTargetDialog';

import * as reactGlobalClick from '../../../../_common/platform/ts/reactGlobalClick';
import { IValuesCollection } from '../../../../_common/platform/ts/appTheme';

import FormEditMixin, {
    IFormEditMixinComponentProperties,
    IFormEditMixinComponentOptions
} from '../../../../_common/platform/tsx/mixins/FormEditMixin';
import SelectField from '../../../../_common/platform/ts/SelectField';

interface IConfigEditOptions extends IFormEditMixinComponentOptions {
    theme?: IValuesCollection;
}

interface IConfigEditProperties extends IFormEditMixinComponentProperties<IConfigEditOptions> {
    active?: boolean;
    theme?: IValuesCollection;
    value?;
    widgetProps?;
    hideSettings?: boolean;
    showEditPaste?: boolean;
    tabID?: number;
    glob: IGlob;
}

interface IConfigEditState {
    value;
    widgetDataEdit: WidgetData;
}

export default class ConfigEdit extends React.Component<IConfigEditProperties, IConfigEditState> {
    //For FormEditMixin.
    //LL: 11.10.21: 'preserve'
    public fields = ['autoSize', 'inlineMode', 'width', 'height', 'widget', 'preserve'];
    public returnInvalid = true;

    private formEditMixin: FormEditMixin<IConfigEditProperties, IConfigEditOptions> = new FormEditMixin(this);
    //private editViewValidationMixin: EditViewValidationMixin = new EditViewValidationMixin(this);

    handleChange(param, name, value) {
        return this.formEditMixin.handleChange(param, name, value);
    }

    validateAll(params) {
        return this.formEditMixin.validateAll(params);
    }

    getField(param, name) {
        return this.formEditMixin.getField(param, name);
    }

    constructor(props) {
        super(props);

        let widgetDataEdit: WidgetData;

        if (
            this.props.value.widget &&
            this.props.value.widget.length > 0 &&
            this.props.widgetProps.paramOptions.values
        ) {
            const widget = this.props.value.widget[0];

            widgetDataEdit = WidgetData.getFromObj(
                widget,
                this.props.glob,
                false,
                this.props.widgetProps.paramOptions.values.htmlContainerTheme,
                this.props.tabID
            );
        }
        const editFields = ConfigEdit.getEditFields(
            this.props.value,
            this.props.glob,
            this.props.tabID,
            this.props.widgetProps
        );
        let value = this.props.value;
        if (editFields.wUnits?.options?.values?.length == 1) {
            value.wUnits = editFields.wUnits?.options?.values[0];
        }
        this.state = {
            value: value,
            widgetDataEdit: widgetDataEdit
        };
    }

    componentWillUpdate(nextProps: IConfigEditProperties, nextState: IConfigEditState) {
        if (!compareObjects(nextState.value, this.state.value)) {
            let widget;
            let widgetDataEdit: WidgetData;

            if (nextState.value && nextState.value.widget && nextState.value.widget.length > 0) {
                widget = nextState.value.widget[0];
                widgetDataEdit = WidgetData.getFromObj(widget, nextProps.glob, false, null, this.props.tabID);
            }

            this.setState({
                value: nextState.value,
                widgetDataEdit: widgetDataEdit
            });
        }
    }

    public static validateFields(obj, params) {
        return EditViewValidationMixin.validateFields(obj, params);
    }

    public static getEditFields(value, glob: IGlob, tabID: number, widgetProps?) {
        let width, height;
        let wUnits, hUnits;
        let margins, marginsExpl; //LL: 08.06.22: To use when a parent div with margins is defined; use in Document mode

        //LL: 25.11.21:
        // No, use AutoSize as Setting (when not Inline and W or H is not set), but without own checkbox

        //LL: 15.10.21: Our decision:
        // = Eliminate "AutoSize"
        //     What to do with already set flag? Behave as near to old functionality as possible
        //     Remember that there was not "Preserve" notion.
        //     So, let it be "Inline" without Width - in config. In Widget itself old behavior remains
        // = The following alternatives:
        //     - “Inline” checkbox is off, Width and Height are set (cannot be blank) But can be 0 ??!!
        //     - “Inline” checkbox is on, Height field is hidden, Width field contains actual value or is blank.
        //    This option is recommended for Grids and Pivots.
        //    If Width value is blank (null), Widget Container fills the whole page width (~100%).
        //    Widget Container height is the actual height of the Widget, it works now at least for Grid and Pivot.
        // = LL: So, "preserved" Element is not needed

        //LL: 07.10.21:
        let showWidth = true;
        let showHeight = true;
        //showWidth = !(value.inlineMode && value.preserve !== 'width' || value.autoSize && value.preserve !== 'width');
        //showHeight = !(value.inlineMode && value.preserve !== 'height' || value.autoSize && value.preserve !== 'height');
        //LL: 15.10.21:
        //showWidth = true;
        //showHeight = !(value.inlineMode || value.autoSize);
        //LL: 25.11.21:
        if (value.inlineMode) {
            showWidth = true;
            showHeight = false;
        }

        //LL: 15.10.21:
        let allowNull = false;
        //if (value.autoSize || value.inlineMode) {
        //    allowNull = true;
        //}
        //LL: 25.11.21:
        //if (value.inlineMode) {
        //    allowNull = true;
        //}
        //LL: 26.11.21:
        allowNull = true;

        let optionNumber = {
            allowNull: allowNull,
            applyOnEnter: true,
            //min: 1,
            //showBrokenMinMaxConstraints: true,
            allowZeroInsteadOfNull: true //LL: new
        };

        //let widthStr = 'Width (20-3000)';
        //if (allowNull) {
        //    widthStr = 'Width (20-3000 or blank)';
        //}
        let widthStr = 'Width';

        if (allowNull) {
            widthStr = 'Width (blank for AutoSize)';
        }

        //LL: 25.11.21:
        let allowNullH = true;
        let optionNumberH = {
            allowNull: allowNullH,
            applyOnEnter: true,
            //min: 1,
            //showBrokenMinMaxConstraints: true,
            allowZeroInsteadOfNull: true //LL: new
        };
        let heightStr = 'Height';

        if (allowNullH) {
            heightStr = 'Height (blank for AutoSize)';
        }

        // was validators.number.positive,
        if (showWidth) {
            width = new NumberField(glob, widthStr, [validators.number.range(1, 10000)], 640, optionNumber);
            //wUnits = new SelectField(glob, 'Units', [], 'px', { values: ['px', '%'], display: ['px', '%'] });
            //LL: 25.12.23: prohibit Width in % if not "inline": (maybe at least for Chart & Gauge)
            //   works bad for Chart, Gauges and also not very much sense with not "inline"

            if (
                value.widget &&
                value.widget.length > 0 &&
                ((value.inlineMode && widgetProps?.paramOptions?.inHtmlContainer === true) ||
                    (value.widget[0].type !== 'pdc-widget-chart' && value.widget[0].type !== 'pdc-widget-gauge'))
            ) {
                wUnits = new SelectField(glob, 'Units', [], 'px', {
                    values: ['px', '%'],
                    display: ['px', '%']
                });
            } else {
                wUnits = new SelectField(glob, 'Units', [], 'px', {
                    values: ['px'],
                    display: ['px']
                });
            }
        }

        if (showHeight) {
            height = new NumberField(glob, heightStr, [validators.number.range(1, 10000)], 480, optionNumberH);
            //hUnits = new SelectField(glob, 'Units', [], 'px', { values: ['px', '%'], display: ['px', '%'] });
            //LL: 07.12.23: no sense in '%' for Height
            hUnits = new SelectField(glob, 'Units', [], 'px', {
                values: ['px'],
                display: ['px']
            });
        }

        //LL: 08.06.22: To use when a parent div with margins is defined; use in Document mode
        //LL: !!! - '*' MUST NOT BE THE LAST, otherwise it is converted to "red"* ("mandatory-mark") in ParameterField.tsx
        //   add ' ' or &nbsp ?
        //   Margin/Margins ?
        margins = new NumberField(
            glob,
            'Horizontal Margin Compensation (*)',
            [validators.number.range(1, 10000)],
            null,
            optionNumber
        );
        //margins = new NumberField(glob, 'Horizontal <b>Margins</b> (*)', [validators.number.range(1, 10000)], null, optionNumber);
        //const mText = ' Set "Horizontal Margins" when Width is not set and in HTML Container there is a DIV with margin/padding that contains this widget.' +
        //    ' Is used in Print Preview Mode.';
        //const mText =
        //    ' Set "Horizontal Margin" when in HTML Container there is a DIV with left/right margin/padding that contains this widget and Width is not set.' +
        //    ' Option is used in Print Preview Mode.';
        const mText =
            ' Set "Horizontal Margin Compensation" when in HTML Container there is a manually-added Parent DIV with left/right margin/padding that contains this widget and Width is not set.' +
            ' Option is used in Print Preview Mode.';
        marginsExpl = (
            <p>
                <strong>(*)</strong>
                {mText}
            </p>
        );

        //LL: 25.11.21: No, use AutoSize, but without Checkbox
        //LL: 15.10.21: Eliminate "AutoSize", transform it to "Inline"

        let autoSize;
        let autoSizeObsolete; //LL: 15.10.21
        let preserve;

        // if (!value.inlineMode) {
        //     //autoSize = new BooleanField(glob, 'Auto Size', [], false); //LL: 15.10.21: rem
        // }

        // if (value.autoSize) {
        //     //LL: 25.11.21: commented
        //     //LL: 15.10.21:
        //     //autoSizeObsolete = new BooleanField(glob, 'Inline', [], true);
        // }

        let inlineMode;
        //LL: 25.11.21: "if" commented
        //if (!value.autoSize) {
        inlineMode = new BooleanField(glob, 'Inline', [], false);
        //}
        // if (value.inlineMode) {
        // }

        return {
            autoSize,
            autoSizeObsolete, //LL: 15.10.21
            inlineMode,
            preserve, //LL: 07.10.21

            widget: new MultiWidgetField(
                glob,
                '',
                [
                    ([widget]) => {
                        if (widget.type == null) {
                            return ['Cannot add empty widget. Type should be specified.'];
                        }
                    }
                ],
                null,
                {
                    noTitle: true,
                    parentTheme: () => {
                        return widgetProps && widgetProps.paramOptions && widgetProps.paramOptions.themeObj;
                    },
                    tabID: tabID,
                    disabledTypes: [
                        'pdc-widget-html',
                        'pdc-widget-drill-down',
                        'pdc-widget-workspace',
                        //'pdc-widget-multiple',
                        'pdc-widget-layout'
                    ]
                },
                _.extend(
                    {
                        noTabs: true
                    },
                    widgetProps
                )
            ),
            width,
            wUnits,
            height,
            hUnits,
            margins,
            marginsExpl
        };
    }

    setFieldValues = (id: number, type: string, values) => {
        this.props.glob.AppActions.configSetFieldValues(id, type, values);
    };

    setWidgetType = (id: number, type: string) => {
        this.props.glob.AppActions.configSetWidgetType(id, type);
    };

    setWidgetLayout = (id: number, layout) => {
        this.props.glob.AppActions.configSetWidgetLayout(id, layout);
    };

    tryPaste = (jsonStr: string) => {
        try {
            const obj = JSON.parse(jsonStr);

            Utils.jsonNormalize_DataSourceNameToID(obj, this.props.glob);
            Utils.jsonNormalize_ThemeNameToID(obj, this.props.glob);

            const pastedWidgetData = WidgetData.getFromJSON(JSON.stringify(obj), this.props.glob, true).widgetData;

            if (pastedWidgetData.type != 'pdc-widget-kpi') {
                this.props.glob.AppActions.showNotification_Fail(
                    'Cannot paste other than KPI widget into this container',
                    null
                );
                return;
            }

            pastedWidgetData.def.done(() => {
                pastedWidgetData.id = this.state.widgetDataEdit.id;

                if (this.state.widgetDataEdit.id == null) {
                    pastedWidgetData.cid = this.state.widgetDataEdit.cid;
                }

                const widget: any = [];

                obj.id = pastedWidgetData.id;
                obj.cid = pastedWidgetData.cid;

                widget.push(obj);

                this.setState({
                    widgetDataEdit: pastedWidgetData
                });

                this.state.value.widget = widget;

                const id = pastedWidgetData.id || pastedWidgetData.cid;

                this.setWidgetType(id, pastedWidgetData.type);
                this.setFieldValues(id, pastedWidgetData.type, pastedWidgetData.widget.values);
                this.setWidgetLayout(id, pastedWidgetData.layout);
            });
        } catch (e) {
            this.props.glob.AppActions.showNotification_Fail('Cannot paste widget data into this container', null);
        }
    };

    edit = (e) => {
        var _self = this;
        var text;

        if (this.state.widgetDataEdit.getDataForSave()) {
            text = JSON.stringify(this.state.widgetDataEdit.getDataForSave(), null, '\t');
        }

        this.props.glob.AppStore.saveToLocalStorage('pdc_clipboard_editdata', text);

        this.props.glob.DialogActions.createDialog(
            'Edit Widget Configuration as JSON',

            null,

            (obj) => {
                _self.tryPaste(obj);
            },

            () => {},
            () => {},

            'custom',

            {
                deny: false,
                confirmTitle: 'Save',
                Component: EditTargetDialog,
                componentOptions: {
                    theme: _self.props.theme,
                    dataSourceID: Utils.getDataSourceID(text)
                },
                resizable: true,
                minHeight: 210
            }
        );
    };

    handleOnPaste = (value: string) => {
        this.tryPaste(value);
    };

    handleOnContainerClick = (e) => {
        reactGlobalClick.trigger(e);
        reactGlobalClick.cancel();
    };

    render() {
        const editFields = ConfigEdit.getEditFields(
            this.state.value,
            this.props.glob,
            this.props.tabID,
            this.props.widgetProps
        );

        if (this.props.active === true) {
            this.validateAll(editFields);
        }

        let autoSize; //LL: 15.10.21: now not used
        //LL: 25.11.21: commented
        //if (editFields.autoSize != null) {
        //    autoSize = <div className="col-sm-2">{ this.getField(editFields.autoSize, 'autoSize') }</div>;
        //}

        //LL: 25.11.21: no now
        let autoSizeObsolete; //LL: 15.10.21  Use value 'inlineMode'? No, some fictive ~~ 'autoSizeFictiv'? No, just 'autoSize'
        //LL: value is changed in pdc-widgets.ts: in getWidgetDefinition edit:, glob.DialogActions.createDialog->getEditFields
        //    Unset autoSize if possible there
        if (editFields.autoSizeObsolete != null) {
            autoSizeObsolete = <div className="col-sm-2">{this.getField(editFields.autoSizeObsolete, 'autoSize')}</div>;
        }

        //LL: 25.11.21: always null, not used
        let preserve; //LL: for autoSize and inlineMode
        if (editFields.preserve != null) {
            preserve = <div className="col-sm-3">{this.getField(editFields.preserve, 'preserve')}</div>;
        }

        let inlineMode;
        if (editFields.inlineMode != null) {
            inlineMode = <div className="col-sm-2">{this.getField(editFields.inlineMode, 'inlineMode')}</div>;
        }

        let width;
        let wUnits;
        if (editFields.width != null) {
            width = <div className="col-sm-2">{this.getField(editFields.width, 'width')}</div>;
            wUnits = <div className="col-sm-1">{this.getField(editFields.wUnits, 'wUnits')}</div>;
        }

        let height;
        let hUnits;
        if (editFields.height != null) {
            height = <div className="col-sm-2">{this.getField(editFields.height, 'height')}</div>;
            hUnits = <div className="col-sm-1">{this.getField(editFields.hUnits, 'hUnits')}</div>;
        }

        //LL: 08.06.22: To use when a parent div with margins is defined; use in Document mode
        let margins;
        if (editFields.margins != null) {
            margins = <div className="col-sm-3">{this.getField(editFields.margins, 'margins')}</div>;
        }
        let marginsExpl;
        if (editFields.marginsExpl != null) {
            marginsExpl = <div className="col">{editFields.marginsExpl}</div>;
        }

        let settings;
        if (this.props.hideSettings !== true) {
            //settings = (
            //    <div className="row" style={ { marginBottom: "10px" } }>
            //        { autoSize }
            //        { autoSizeObsolete }
            //        { inlineMode }
            //        { preserve }
            //        { width }
            //        { height }
            //        { margins }
            //    </div>
            //);
            settings = (
                <React.Fragment>
                    <div className="row" style={{ marginBottom: '0px' }}>
                        {autoSize}
                        {autoSizeObsolete}
                        {inlineMode}
                        {preserve}
                        {width}
                        {wUnits}
                        {height}
                        {hUnits}
                        {margins}
                    </div>
                    <div className="row" style={{ marginBottom: '10px' }}>
                        {marginsExpl}
                    </div>
                </React.Fragment>
            );
        }

        var style: any = {
            display: 'inline-block',
            whiteSpace: 'nowrap'
        };

        let editPaste;

        if (this.props.showEditPaste == true) {
            editPaste = (
                <div>
                    <div style={style}>
                        <div className="btn btn-default" onClick={this.edit}>
                            <span className="glyphicon glyphicon-edit" />
                            {'Edit JSON'}
                        </div>
                    </div>

                    <div style={style}>
                        <PasteButton theme={this.props.theme} glob={this.props.glob} onPaste={this.handleOnPaste} />
                    </div>
                </div>
            );
        }

        return (
            <div className="widget-parameters-edit template-edit" onClick={this.handleOnContainerClick}>
                {settings}

                <div className="row">
                    <div className="col-sm-12 text-right">{editPaste}</div>
                    <div className="col-sm-12">{this.getField(editFields.widget, 'widget')}</div>
                </div>
            </div>
        );
    }
}
